import Router from "next/router";

export const dispatchAckoDriveCallback = async (props) => {
    const { data } = props
    try {
        const { proposal_ekey } = Router.query;
        const ackoDriveLeadsUrl = `${process.env.SDUI_API_SERVICE}/ackodrive-lead/${proposal_ekey}`
        fetch(ackoDriveLeadsUrl, {
            method: "POST",
            body: JSON.stringify(data)
        })
    } catch (e) {
        console.error(e);
        return null;
    }
}